import Axios from 'axios';

class InstitutionsService {
  getInstitution(id) {
    return Axios.get(`/admin/institutions/${id}`);
  }

  getInstitutions(institutionSearch, page) {
    return Axios.get('/admin/institutions', {
      params: {
        search: institutionSearch,
        page,
      },
    });
  }

  searchInstitution(reference) {
    return Axios.get('/admin/available-institutions', {
      params: { reference },
    });
  }

  validateImport(importFile, institutionId, type) {
    const form = new FormData();
    const headers = { 'Content-Type': 'multipart/form-data' };

    form.append('import_file', importFile);
    form.append('institution_id', institutionId);
    form.append('import_type', type);

    return Axios.put('/admin/validate-importation', form, { headers });
  }

  confirmImport(institutionId, spreadsheetId, spreadsheetURL, type) {
    return Axios.put('/admin/confirm-importation', {
      institution_id: institutionId,
      spreadsheet_id: spreadsheetId,
      spreadsheet_url: spreadsheetURL,
      import_type: type,
    });
  }

  getInstitutionPlaces(institutionId) {
    return Axios.post('/admin/model_list', {
      model_name: 'InstitutionPlace',
      filters: {
        institution_id: institutionId,
      },
    });
  }

  getBillingInstitutions(institutionSearch, page) {
    return Axios.get('/admin/billing_institutions', {
      params: {
        search: institutionSearch, page,
      },
    });
  }

  editInstitution(institution) {
    return Axios.post('/admin/billing_institution', { institution });
  }
}

export default new InstitutionsService();
